__turbopack_context__.v({
  "header": "Header-module-scss-module__febDpa__header",
  "hidden": "Header-module-scss-module__febDpa__hidden",
  "hideTopRibbon": "Header-module-scss-module__febDpa__hideTopRibbon",
  "hideTopRibbonAndStoreSelector": "Header-module-scss-module__febDpa__hideTopRibbonAndStoreSelector",
  "isScrolledToTop": "Header-module-scss-module__febDpa__isScrolledToTop",
});
